import React, {useEffect } from "react";
import "./App.css";
import {
  Admin,
  CustomRoutes,
  defaultTheme,
  Resource,
  useGetIdentity,
  usePermissions,
  useStore,
} from "react-admin";
import {
  Outlet,
  Route,
  useNavigate,
} from "react-router-dom";
import { dataProvidersAts } from "./dataproviders/DataProvidersAts";
import Inbox from "./Container/ATS/Inbox";
import MyLayout from "./componets/MyLayout";
import CustomNotification from "./componets/common/CustomNotification";
import "./assets/styles/style.css";
import ApplicantDetailEdit from "./componets/Ats/ApplicantDetailEdit";
import { Provider, useDispatch } from "react-redux";
import store from "./Store/store";
import {
  setUserRole,
  setaspNetUserId,
} from "./Store/Slice/usersSlice";
import InboxAdmin, {
  Getglobalsearch,
} from "./Container/ATS/InboxAdmin";
import SubscriberAdminUsage from "./Container/ATS/SubscriberAdminUsage";
import Login from "./Container/Login/Login";
import authProvider from "./authProviders/authProviders";
import Getloginactivitylogs, {
  GetAuditLogs,
} from "./Container/ATS/Getloginactivitylogs";
import Getarchivedcancelled from "./Container/ATS/Getarchivedcancelled";
import DocumentView from "./componets/Ats/DocumentView";
import ForgotPassword from "./Container/Login/ForgotPassword";
import DataPrivacy from "./Container/Login/DataPrivacy";
import TermsOfUse from "./Container/Login/TermOfUse";
import ApplicationRegistration from "./componets/ApplicationRegistration/ApplicationRegistration";
import ResetPassword from "./Container/Login/ResetPassword";
import ProfileDetails from "./Container/ATS/ProfileDetails";
import ApplicationSettings from "./Container/ATS/ApplicationSettings";
import AddNewProfile from "./Container/ATS/AddNewProfile";
import EmailSettings from "./componets/Settings/EmailSettings/EmailSettings";
import TemplateDetails from "./componets/Settings/EmailSettings/TemplateDetails";
import SubscriberTemplateDetails from "./componets/Settings/EmailSettings/SubscriberTemplateDetails";
import PropertyList from "./componets/Settings/PropertySetup/PropertyList";
import AddNewProperty from "./componets/Settings/PropertySetup/AddNewProperty";
import PropertyDetails from "./componets/Settings/PropertySetup/PropertyDetails";
import AddAndUpdateFloor from "./componets/Settings/PropertySetup/AddAndUpdateFloor";
import AddAndUpdateUnit from "./componets/Settings/PropertySetup/AddAndUpdateUnit";
import ManageSubscribersList from "./componets/manageSubscribers/ManageSubscribersList";
import { typesofUsers } from "./config";
import AddorUpdateSubscriber from "./componets/manageSubscribers/AddorUpdateSubscriber";
import EntrataList from "./componets/Settings/IntegrationSettings/Entrata/EntrataList";
import AddorUpdateIntegrationSettings from "./componets/Settings/IntegrationSettings/Entrata/AddorUpdateIntegrationSettings";
import YardiList from "./componets/Settings/IntegrationSettings/Yardi/YardiList";
import HierarchyLevelList from "./componets/Settings/HierarchyLevel/HierarchyLevelList";
import AddorUpdateHierarchyLevel from "./componets/Settings/HierarchyLevel/AddorUpdateHierarchyLevel";
import UpdateStripeAccount from "./componets/Settings/PropertySetup/UpdateStripeAccount"
import { useUserRole } from "./hooks/useUserRoleHook";
import TermsandCondtions from "./Container/TermsandCondtions/TermsandCondtions";
import OcrQueue from "./componets/OcrQueue/OcrQueue";
import TermsandCondtionsAdmin, { TermsandCondtionsAdmin_Landoard, TermsandCondtionsAdmin_Privacy, TermsandCondtionsAdmin_Subscriber, TermsandCondtionsAdmin_termsofuse } from "./Container/TermsandCondtionsAdmin/TermsandCondtions";
import UpdateTemplateDetails from "./componets/Settings/EmailSettings/UpdateTemplateDetails";
import AdminEmailSettings from "./Container/ATS/AdminEmailSettings";
import UpdateAdminTemplateDetail from "./Container/ATS/UpdateAdminTemplateDetail";
import { UserRoleProvider } from "./ContextApi/UserRoleContext";
import UserSetup from "./componets/Settings/UserSetup/UserSetup";
import AddOrUpdateUser from "./componets/Settings/UserSetup/AddOrUpdateUser";
import UpdateUser from "./componets/Settings/UserSetup/UpdateUser";
import UserLogs from "./componets/Settings/UserSetup/UserLogs";
import ManageUsers from "./componets/manageUsers/ManageUsers";
import AddUserForAdmin from "./componets/manageUsers/AddUserForAdmin";
import UpdateUserForAdmin from "./componets/manageUsers/UpdateUserForAdmin";

import TempPassWordResetUserSetup from "./Container/ATS/TempPassWordResetUserSetup";
import TermsAndConditionForUserSetup from "./Container/ATS/TermsConditionUserSetup";
import { LeadManagementReportResource } from "./componets/SubscriberManagementReport/LeadMangement";
import RevenueManagementReportResource from "./componets/SubscriberManagementReport/RevenueManagement";
import { DocuploadManagementReportResource } from "./componets/SubscriberManagementReport/DocuploadManagement";
import AdminPlaidManagement from "./Container/ATS/AdminPlaidManagement";
import AdminLeadManagement from "./Container/ATS/AdminLeadManagement";
import AdminScreeningManagement from "./Container/ATS/AdminScreeningManagement";
import AdminRevenueManagement from "./Container/ATS/AdminRevenueManagement";
import AdminVerificationManagement from "./Container/ATS/AdminVerificationReport";

import ForgotUsername from "./Container/Login/ForgotUsername";
import TermsConditionLandLoardSetup from "./Container/ATS/TermsConditionLandLoardSetup";
import InboxLandLoard from "./Container/ATS/InboxLandLoard";
import { ConfidentialityLogsResource } from "./componets/DocumentAnalysis/components/ConfidentialityLogs/Confidentialitylogs";
import { AdverseLetterResource } from "./componets/DocumentAnalysis/components/AdverseLetter/AdverseLetter";
import UpdateAdverseLetter from "./componets/DocumentAnalysis/components/AdverseLetter/UpdateAdverseLetter";
import { GeographicalsettingsResource } from "./componets/GeographicalSettings/GeographicalSettings";
import { InvitationLogsResource } from "./componets/InvitationLogs/InvitationLogs";
import AddRole from "./componets/Settings/userPermission/AddRole";
import SubscriberUserPermission from "./componets/Settings/userPermission/SubscriberUserPermission";
import ThirdPartyUserPermission from "./componets/Settings/userPermission/ThirdPartyUserPermission";
import { checkModuleAccess, isSuperAdmin } from "./Functions/permissions";
import {
  adminSwitchNeedsRecovery,
  isSubscriberSwitchActive,
  readSwitchedSubscriberId,
  shouldSuppressAdminInbox,
  switchedSubscriberInboxPath,
} from "./utils/switchedSubscriberInbox";
import SubscriberPermissionOfAdmin from "./componets/AdminPermissions/SubscriberPermissionOfAdmin ";
import AdminAddRole from "./componets/AdminPermissions/AdminAddRole";
import AdminThirdParty from "./componets/AdminPermissions/AdminThirdParty";
import { SystemNotificationResource } from "./componets/AdminSystemNotification/SystemNotification";
import AddNotification from "./componets/AdminSystemNotification/AddNotification";
import UpdateNotification from "./componets/AdminSystemNotification/UpdateNotification";
import SubscriberNotification from "./componets/AdminSystemNotification/SubscriberNotification";
import ViewAdverseLetter from "./componets/Ats/LandLoard/ViewAdverseLetter";
import AplicationProfile from "./componets/Settings/ApplicationProfileSettings/ListApplicationProfile";
import ApplicationProfileCreate from "./componets/Settings/ApplicationProfileSettings/ApplicationProfileCreate";
import ApplicationProfileUpdate from "./componets/Settings/ApplicationProfileSettings/ApplicationProfileUpdate";
import ErrorPage from "./componets/Settings/userPermission/ErrorPage";
import { AdminResources } from "./componets/AdminResources/GetAdminResources";
import { SubscriberResources } from "./componets/AdminResources/GetSubscriberResource";
import AdminCreateResource from "./componets/AdminResources/AdminCreateResource";
import AdminUpdateResource from "./componets/AdminResources/AdminUpdateResource";
import ViewSecondaryAppView from "./componets/Ats/ViewSecondaryAppView";
import { ScheduleReportResource } from "./componets/SubscriberManagementReport/ScheduleReport";
import CreateNewSchedule from "./componets/SubscriberManagementReport/CreateNewSchedule";
import UpdateScheduleReport from "./componets/SubscriberManagementReport/UpdateScheduleReport";

import PredefinedMessage from "./Container/Predefinedmessage/Predefinedmessage";
import EditPredefinedMessage from "./Container/Predefinedmessage/EditPredefinedMessage";
import CreatePredefinedMessage from "./Container/Predefinedmessage/CreatePredefinedMessage";
import PredefinedMessageAdmin from "./Container/PredefinedmessageAdmin/Predefinedmessage";
import EditPredefinedMessageAdmin from "./Container/PredefinedmessageAdmin/EditPredefinedMessage";
import CreatePredefinedMessageAdmin from "./Container/PredefinedmessageAdmin/CreatePredefinedMessage";



const theme = {
  ...defaultTheme,
  sidebar: {
    minwidth: 240, // The default value is 240
    closedWidth: 55, // Icon rail when the sidebar is collapsed
  },
  appbar: {
  },
  typography: {
    fontFamily: ["'Open Sans'", " sans-serif"].join(","),
    fontSize: 12,
    fontWeight: 600,
    LineHeight: 16,
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#2cc0e4",
      contrastText: "#fff",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#0066ff",
      main: "#4BD5E7",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#fff",
    },
    error: {
      main: "#ff4848",
      contrastText: "#fff",
    },
    warning: {
      main: "#f9bb04",
      contrastText: "rgba(0, 0, 0, 0.87)",
    },
    success: {
      main: "#46a96f",
      contrastText: "#fff",
    },
    custom: "#fff",
  },
  components: {
    ...defaultTheme.components,
    MuiTextField: {
      defaultProps: {
        variant: "outlined" as const,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "outlined" as const,
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          color: '#000000', // Black color
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: '#000000', // Black color
        },
      },
    },
  },
};



const TokenValid = (props) => {
  const { data } = useGetIdentity();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (data?.userid !== undefined) {
      dispatch(setaspNetUserId(data?.userid));
    }
    if (data?.userrole !== undefined) {
      dispatch(setUserRole(data?.userrole));
    }
  }, [dispatch, data?.userid, data?.userrole]);
  useEffect(() => {
    if (data?.userrole == "Applicant") {
      if (data.redirectUrl) navigate(data.redirectUrl, { replace: true });
    }
  }, [data]);
  if (data?.userrole != "Applicant" && data?.userrole) return <Outlet />;
  else return <></>;
};

export const SubscriberSwitchValidation = (props) => {
  const [switchSubscriberObj, setSwitchSubscriberObj] = useStore("switchSubscriberName");
  const { data, isLoading } = useGetIdentity();
  const { Component } = props;
  const navigate = useNavigate();
  useEffect(() => {
    if (props.isAdmin && localStorage.getItem("RaStore.switchSubscriber") === "true") {
      navigate(`/ats/Subscriber/Inbox/${switchSubscriberObj?.value}`, { replace: true })
    }
    else if (!props.isAdmin && localStorage.getItem("RaStore.switchSubscriber") === "false") {
      setSwitchSubscriberObj({});
      navigate("/ats", { replace: true });
    }
  }, [data, props])
  useEffect(() => {
    const termconditionStatus = localStorage.getItem("TermAndConditionVefificationStatus");
    if (!data?.isPasswordChanged && !isLoading) {
      navigate('/Ats/TempForgotPassword')
    } else if (!data?.isTandCAccepted && !isLoading && !termconditionStatus) {
      navigate('/Ats/TermsAndConditionForUserSetup')
    }

  }, [data])
  return <Component type={props?.type} />
}

export const Dashbaord = () => {
  const { data, isLoading } = useGetIdentity();
  const navigate = useNavigate();
  const authJson = localStorage.getItem("auth") || "";
  let authObj = authJson ? JSON.parse(authJson) : {};
  const [switchSubscriberObj, setSwitchSubscriberObj] = useStore("switchSubscriberName");
  const [invalidSwitchCleared, setInvalidSwitchCleared] = React.useState(false);
  /* updated By - Pankaj-5437
     Date: 04-Nov-2026
     start
     Opening /ats while Switch Subscriber is active used to mount the admin
     inbox and show every subscriber's ATS and VR queues. Send that session
     back to the selected subscriber inbox. A Docuverus admin switch with no
     selected subscriber is cleared so the admin inbox can render.
  */
  useEffect(() => {
    if (isSubscriberSwitchActive()) {
      const switchedSubscriberId = readSwitchedSubscriberId(switchSubscriberObj);
      if (switchedSubscriberId) {
        navigate(switchedSubscriberInboxPath(switchedSubscriberId), { replace: true });
      }
      return;
    }
    if (authObj)
      navigate('/Ats');
  }, []);

  useEffect(() => {
    if (!isSubscriberSwitchActive()) return;

    const switchedSubscriberId = readSwitchedSubscriberId(switchSubscriberObj);
    if (switchedSubscriberId) {
      navigate(switchedSubscriberInboxPath(switchedSubscriberId), { replace: true });
      return;
    }

    if (adminSwitchNeedsRecovery(data?.subscriberView, switchSubscriberObj)) {
      localStorage.setItem("RaStore.switchSubscriber", JSON.stringify(false));
      setSwitchSubscriberObj({ value: "", label: "", companyType: "" });
      setInvalidSwitchCleared(true);
    }
  }, [switchSubscriberObj?.value, data?.subscriberView]);
  /* end */

  useEffect(() => {
    if (data?.userrole == "Applicant") {
      if (data.redirectUrl) navigate(data.redirectUrl, { replace: true });
    }
    if (data?.userrole === "Docuverus Super Admin" && localStorage.getItem("RaStore.switchSubscriber") === null) {
      localStorage.setItem("RaStore.switchSubscriber", JSON.stringify(false))
    }
    if ((data?.userrole === "Agent" || data?.userrole === "Manager") && localStorage.getItem("RaStore.switchSubscriber") === null) {
      localStorage.setItem("RaStore.switchSubscriber", JSON.stringify(true))
    };
    if (data?.userrole === "Admin") {
      setSwitchSubscriberObj({ value: data?.subscriberid, label: data?.fullName, companyType: data?.subscribertype });
    }
    if (data?.userrole === "Docuverus Admin" && localStorage.getItem("RaStore.switchSubscriber") === null) {
      localStorage.setItem("RaStore.switchSubscriber", JSON.stringify(false))
    };
  }, [data])
  useEffect(() => {
    const termconditionStatus = localStorage.getItem("TermAndConditionVefificationStatus");
    if (!data?.isPasswordChanged && !isLoading) {
      navigate('/Ats/TempForgotPassword')
    } else if (!data?.isTandCAccepted && !isLoading && !termconditionStatus) {
      navigate('/Ats/TermsAndConditionForUserSetup')
    }

  }, [data])

  const userRole = useUserRole();
  const { permissions } = usePermissions();
  if (data?.userrole === typesofUsers?.docuverusSuperAdmin && !checkModuleAccess(permissions, "Dashboard", "")) {
    return <ErrorPage />;
  } else if (!isSuperAdmin(checkModuleAccess(permissions, "Dashboard", ""), data?.userrole)) {
    return <ErrorPage />;
  }
  /* updated By - Pankaj-5437
     Date: 04-Nov-2026
     start
     subscriberView false means the signed-in user is a Docuverus admin.
     If that admin has switched into a subscriber, do not render InboxAdmin.
     InboxAdmin loads getAdminAllinboxType, which is the all-subscriber
     ATS and VR queue.
  */
  if (data?.userrole != "Applicant" && data?.userrole) {
    if (data?.subscriberView) {
      return <Inbox />;
    }
    if (shouldSuppressAdminInbox(data?.subscriberView, invalidSwitchCleared)) {
      return <></>;
    }
    return <InboxAdmin />;
  }
  /* end */
  return <InboxLandLoard />
};

const AtsApp = () => {
  return (
    <Provider store={store}>
      <Admin
        theme={theme}
        dashboard={Dashbaord}
        layout={MyLayout}
        authProvider={authProvider}
        requireAuth
        loginPage={Login}
        basename="/Ats"
        dataProvider={dataProvidersAts}
        notification={CustomNotification}
      >

        <CustomRoutes>


          <Route
            path="/SubscriberUsageList"
            element={<SubscriberSwitchValidation isAdmin={true} Component={SubscriberAdminUsage} />}
          />
          <Route
            path="/getloginactivitylogs"
            element={<SubscriberSwitchValidation isAdmin={true} Component={Getloginactivitylogs} />}
          />
          <Route
            path="/getocrqueuelist"
            element={<SubscriberSwitchValidation isAdmin={true} Component={OcrQueue} />}
          />

          <Route
            path="/getscreeningmanagementreportdv"
            element={<SubscriberSwitchValidation isAdmin={true} Component={RevenueManagementReportResource} />}
          />

          <Route
            path="/adminlead"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminLeadManagement} />}
          />
          <Route
            path="/geographicalsetting"
            element={<SubscriberSwitchValidation isAdmin={true} Component={GeographicalsettingsResource} />}
          />

          <Route
            path="/adminverification"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminVerificationManagement} />}
          />
          <Route
            path="/adminplaidmanagement"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminPlaidManagement} />}
          />
          <Route
            path="/adminscreen"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminScreeningManagement} />}
          />
          <Route
            path="/adminrevenue"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminRevenueManagement} />}
          />

          <Route
            path="/getEmailSettings/admintemplateDetails/:id"
            element={<SubscriberSwitchValidation isAdmin={true} Component={UpdateAdminTemplateDetail} />}
          />
          <Route
            path="/getglobalsearch"
            element={<SubscriberSwitchValidation isAdmin={true} Component={Getglobalsearch} />}
          />
          <Route
            path="/termsandconditions_applicant"
            element={<SubscriberSwitchValidation isAdmin={true} Component={TermsandCondtionsAdmin} />}
          />
          <Route
            path="/termsandconditions_subscriber"
            element={<SubscriberSwitchValidation isAdmin={true} Component={TermsandCondtionsAdmin_Subscriber} />}
          />
          <Route
            path="/termsandconditions_landloard"
            element={<SubscriberSwitchValidation isAdmin={true} Component={TermsandCondtionsAdmin_Landoard} />}
          />
          <Route
            path="/termsandconditions_privacy"
            element={<SubscriberSwitchValidation isAdmin={true} Component={TermsandCondtionsAdmin_Privacy} />}
          />
          <Route
            path="/termsandconditions_termsofuse"
            element={<SubscriberSwitchValidation isAdmin={true} Component={TermsandCondtionsAdmin_termsofuse} />}
          />
          <Route
            path="/adverseletter"
            element={<ViewAdverseLetter />}
          />
          <Route path="/Subscriber" element={<TokenValid />}>

            <Route path="/Subscriber/Inbox/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={Inbox} />} />
            <Route
              path="/Subscriber/getarchivedcancelled/:id"
              element={<SubscriberSwitchValidation isAdmin={false} Component={Getarchivedcancelled} />}
            />
            <Route
              path="/Subscriber/Inbox/:id/edit/:applicationId/:appType"
              element={<UserRoleProvider defaultRole=""><ApplicantDetailEdit /></UserRoleProvider>}
            />
            <Route
              path="/Subscriber/Inbox/:id/edit/:applicationId/:appType/auditlogs/:applicantId"
              element={<SubscriberSwitchValidation isAdmin={false} Component={GetAuditLogs} />}
            />

          </Route>
          <Route
            path="Copy/Property/:applicationType/:parm1/:parm2/:parm3"
            element={<>Property Docupload / Guest card </>}
          />
          <Route
            path="Copy/Office/:applicationType/:parm1/:parm2/:parm3"
            element={<>Office Guest card / Docupload</>}
          />

          <Route path="/dashboard/login" element={<Login />} />
          <Route path="/docview" element={<DocumentView />} />
          <Route path="/secondaryAppView" element={<ViewSecondaryAppView />} />
          <Route path="/emailSettings/" element={<EmailSettings />} />
          <Route
            path="/emailSettings/templateDetails"
            element={<TemplateDetails />}
          />
          <Route path="/settings/getleadmanagementreport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={LeadManagementReportResource} />
            } />
          <Route path="/settings/getrevenuemanagementreport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={RevenueManagementReportResource} />

            } />

          <Route path="/managementreport/getleadmanagementreport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={LeadManagementReportResource} />
            } />
          <Route path="/managementreport/getrevenuemanagementreport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={RevenueManagementReportResource} />

            } />
          <Route path="/settings/getconfidentialitylogs"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ConfidentialityLogsResource} />
            } />

          <Route path="/settings/getinvitationlogs"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={InvitationLogsResource} />
            } />
          <Route path="/settings/getadverseletter"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={AdverseLetterResource} />
            } />
          <Route path="/settings/applicationProfile"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={AplicationProfile} />
            } />
          <Route path="/settings/applicationProfile/create"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ApplicationProfileCreate} />
            } />
          <Route path="/settings/applicationProfile/create/:id"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ApplicationProfileCreate} />
            } />
          <Route path="/settings/applicationProfile/:id/applicationSettings"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ApplicationSettings} />
            } />
          <Route path="/settings/applicationProfile/edit/:id"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ApplicationProfileUpdate} />
            } />
          <Route path="/settings/getadverseletter/adversetemplateDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={UpdateAdverseLetter} />} />

          <Route path="/managementreport/getdocuploadmanagementreport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={DocuploadManagementReportResource} />

            } />
          <Route path="/managementreport/ScheduleReport"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={ScheduleReportResource} />

            } />

          <Route path="/managementreport/ScheduleReport/addSchedule"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={CreateNewSchedule} />

            } />
          <Route path="/managementreport/scheduleReport/updateSchedule/:id"
            element={
              <SubscriberSwitchValidation isAdmin={false}
                Component={UpdateScheduleReport} />

            } />
          <Route path="/managementreport/ScheduleReport" element={<Resource name="getScheduleReport" list={ScheduleReportResource} />} />
          <Route
            path="/emailSettings/subscriberTemplateDetails"

            element={<SubscriberTemplateDetails />}
          />
          <Route
            path="/emailSettings/profiledetails"
            element={<ProfileDetails />}
          />
          <Route
            path="/emailSettings/applicationsettings"
            element={<ApplicationSettings />}
          />

          <Route
            path="/emailSettings/addnewprofile"
            element={<AddNewProfile />}
          />

          <Route path="/settings/propertySetup/" element={<Resource name='Property' list={<SubscriberSwitchValidation isAdmin={false} Component={PropertyList} />} />} />
          <Route path="/settings/propertySetup/addNewProperty" element={<SubscriberSwitchValidation isAdmin={false} Component={AddNewProperty} />} />
          <Route path="/settings/propertySetup/propertyDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={PropertyDetails} />} />
          <Route path="/settings/propertySetup/propertyDetails/:id/addNewFloor" element={<SubscriberSwitchValidation isAdmin={false} Component={AddAndUpdateFloor} />} />
          <Route path="/settings/propertySetup/propertyDetails/:id/addNewUnit" element={<SubscriberSwitchValidation isAdmin={false} Component={AddAndUpdateUnit} />} />
          <Route path="/settings/propertySetup/propertyDetails/:id/floorDetails/:floorId" element={<SubscriberSwitchValidation isAdmin={false} Component={AddAndUpdateFloor} />} />
          <Route path="/settings/propertySetup/propertyDetails/:id/unitDetails/:unitId" element={<SubscriberSwitchValidation isAdmin={false} Component={AddAndUpdateUnit} />} />
          <Route path="/settings/propertySetup/propertyDetails/stripeAccount/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={UpdateStripeAccount} />} />
          <Route
            path="/settings/termsandconditions"
            element={<SubscriberSwitchValidation isAdmin={false} Component={TermsandCondtions} />
            }
          />
          <Route path="/settings/officeSetup/" element={<Resource name='get-office' list={<SubscriberSwitchValidation isAdmin={false} Component={PropertyList} type={"Office"} />} />} />
          <Route path="/settings/officeSetup/addNewOffice" element={<SubscriberSwitchValidation isAdmin={false} Component={AddNewProperty} />} />
          <Route path="/settings/officeSetup/officeDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={PropertyDetails} />} />
          <Route path="/settings/officeSetup/officeDetails/stripeAccount/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={UpdateStripeAccount} />} />
          <Route path="/manageSubscribers" element={<Resource name='subscriber-list' list={<SubscriberSwitchValidation isAdmin={true} Component={ManageSubscribersList} />} />} />
          <Route path="/manageSubscribers/addNewSubscriber" element={<SubscriberSwitchValidation isAdmin={true} Component={AddorUpdateSubscriber} />} />
          <Route path="/manageSubscribers/subscriberDetails/:id" element={<SubscriberSwitchValidation isAdmin={true} Component={AddorUpdateSubscriber} />} />
          <Route path="/getEmailSettings" element={<Resource name='admin-email-template-list' list={<SubscriberSwitchValidation isAdmin={true} Component={AdminEmailSettings} />} />} />
          <Route path="/manageUsers" element={<Resource name='user-setup-admin' list={<SubscriberSwitchValidation isAdmin={true} Component={ManageUsers} />} />} />

          <Route path="/predefinedMessage" element={<SubscriberSwitchValidation isAdmin={true} Component={PredefinedMessageAdmin} />} />
          <Route path="/predefinedMessage/:id" element={<SubscriberSwitchValidation isAdmin={true} Component={EditPredefinedMessageAdmin} />} />
          <Route path="/predefinedMessage/create" element={<SubscriberSwitchValidation isAdmin={true} Component={CreatePredefinedMessageAdmin} />} />


          <Route path="/manageUsers/ManageUsers/addNewAdminUser" element={<SubscriberSwitchValidation isAdmin={true} Component={AddUserForAdmin} />} />

          <Route path="/manageUsers/ManageUsers/updateNewAdminUser/:Id" element={<SubscriberSwitchValidation isAdmin={true} Component={UpdateUserForAdmin} />} />
          <Route
            path="/adminnotification"
            element={<SubscriberSwitchValidation isAdmin={true} Component={SystemNotificationResource} />}
          />
          <Route path="/sub" element={<SubscriberSwitchValidation isAdmin={true} Component={SubscriberNotification} />} />
          <Route path="/adminnotificatio/updateNotification/:id" element={<SubscriberSwitchValidation isAdmin={true} Component={UpdateNotification} />} />
          <Route path="/adminnotification/addnotification" element={<SubscriberSwitchValidation isAdmin={true} Component={AddNotification} />} />
          <Route
            path="/adminresource"
            element={<SubscriberSwitchValidation isAdmin={true} Component={AdminResources} />}
          />
          <Route
            path="/subscriberresource"
            element={<SubscriberSwitchValidation isAdmin={false} Component={SubscriberResources} />}
          />
          <Route path="/adminresource/addresource" element={<SubscriberSwitchValidation isAdmin={true} Component={AdminCreateResource} />} />
          <Route path="/adminresource/updateresource/:id" element={<SubscriberSwitchValidation isAdmin={true} Component={AdminUpdateResource} />} />
          <Route path="/settings/integrationSettings/entrata" element={<Resource name='integration-setting-rule-entrata' list={<SubscriberSwitchValidation isAdmin={false} Component={EntrataList} />} />} />
          <Route path="/settings/integrationSettings/entrata/addIntegrationSettings" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateIntegrationSettings} />} />
          <Route path="/settings/integrationSettings/entrata/entrataDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateIntegrationSettings} />} />
          <Route path="/settings/integrationSettings/yardi" element={<Resource name='integration-setting-rule-yardi' list={<SubscriberSwitchValidation isAdmin={false} Component={YardiList} />} />} />
          <Route path="/settings/integrationSettings/yardi/addyardiIntegrationSettings" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateIntegrationSettings} />} />
          <Route path="/settings/integrationSettings/yardi/yardiDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateIntegrationSettings} />} />
          <Route path="/settings/hierarchyLevel" element={<Resource name='hierarchy-levels-list' list={<SubscriberSwitchValidation isAdmin={false} Component={HierarchyLevelList} />} />} />
          <Route path="/settings/hierarchyLevel/addNewLevel" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateHierarchyLevel} />} />
          <Route path="/settings/hierarchyLevel/levelDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={AddorUpdateHierarchyLevel} />} />

          {/* Predeined messages */}
          <Route path="/settings/predefinedMessage" element={<SubscriberSwitchValidation isAdmin={false} Component={PredefinedMessage} />} />
          <Route path="/settings/predefinedMessage/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={EditPredefinedMessage} />} />
          <Route path="/settings/predefinedMessage/create" element={<SubscriberSwitchValidation isAdmin={false} Component={CreatePredefinedMessage} />} />

          {/* admin permission */}
          <Route path="/AdminPermissions" element={<SubscriberSwitchValidation isAdmin={true} Component={SubscriberPermissionOfAdmin} />} />
          <Route path="/AdminPermissions/adminAddRole" element={<SubscriberSwitchValidation isAdmin={true} Component={AdminAddRole} />} />
          <Route path="/thirdParty" element={<SubscriberSwitchValidation isAdmin={true} Component={AdminThirdParty} />} />

          {/* user permission */}
          <Route path="/settings/permission/userpermission" element={<SubscriberUserPermission />} />
          <Route path="/settings/permission/userpermission/AddRole" element={<AddRole />} />
          <Route path="/settings/permission/thirdPartyPermission" element={<ThirdPartyUserPermission />} />
          {/* Email Settings */}
          <Route path="/settings/emailSettings" element={<Resource name='email-template-list' list={EmailSettings} />} />
          <Route path="/settings/emailSettings/templateDetails/:id" element={<SubscriberSwitchValidation isAdmin={false} Component={UpdateTemplateDetails} />} />

          {/* user setup */}
          <Route path="/settings/usersetup" element={<Resource name='user-setup' list={UserSetup} />} />
          <Route path="/settings/usersetup/adduser" element={<SubscriberSwitchValidation isAdmin={false} Component={AddOrUpdateUser} />} />

          <Route path="/settings/usersetup/updateuser/:Id/:UserType" element={<SubscriberSwitchValidation isAdmin={false} Component={UpdateUser} />} />
          <Route path="/settings/usersetup/userlogs/:usernameVal" element={<Resource name='loginuserlogs' list={<SubscriberSwitchValidation isAdmin={false} Component={UserLogs} />} />} />
        </CustomRoutes>
        <CustomRoutes noLayout>
          <Route path="/TempForgotPassword" element={<TempPassWordResetUserSetup />} />
          <Route path="/TermsAndConditionForUserSetup" element={<TermsAndConditionForUserSetup />} />
        </CustomRoutes>
        {/* Resource defined */}
        <Resource name="getsubscriberinbox" />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
      </Admin>
    </Provider>
  );
};

export const PublicRoutes = () => {
  return (
    <Provider store={store}>
      <Admin
        theme={theme}
        dashboard={Dashbaord}
        layout={MyLayout}
        basename="/atss"
        dataProvider={dataProvidersAts}
        notification={CustomNotification}
      >
        <CustomRoutes noLayout>
          <Route path="/Landloard" >
            <Route path="/Landloard/TermsAndConditionForUserLandLoard" element={<TermsConditionLandLoardSetup />} />
          </Route>
        </CustomRoutes>


        <CustomRoutes noLayout>
          <Route path="/ForgotPassword" element={<ForgotPassword />} />

         <Route
            path="/applicationsettings"
            element={<ApplicationSettings />}
          />
          <Route path="/DataPolicy" element={<DataPrivacy />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />
          <Route path="/cp/*" element={<ApplicationRegistration />} />
          <Route path="/resetPassword/:id" element={<ResetPassword />} />
          <Route path="/ForgotPassword" element={<ForgotPassword />} />
          <Route path="/ForgotUsername" element={<ForgotUsername />} />
          <Route path="/DataPolicy" element={<DataPrivacy />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />
          <Route path="/cp/*" element={<ApplicationRegistration />} />
          <Route path="/resetPassword/:id" element={<ResetPassword />} />
          </CustomRoutes>
         </Admin>
    </Provider>
  );
};

export default AtsApp;
